import React from "react";
// import JSONPretty from "react-json-pretty";
import { RevvForm, ReactSelect } from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";

export default class CommonSelectFieldFormMode extends React.Component {
  state = {
    singleLineTextFieldValues: {
      default: JSON.parse(JSON.stringify(this.props.initialProps.value)),
    },
  };

  _handleOnChange = (value, handleChangeByName) => {
    handleChangeByName(value, "default");
    // If there is a value then only
    // make an API call and update the redux store
    if (value) {
      const { id } = this.props.initialProps;
      this.props._updateDynamicFieldsInDoc(id, value);
      this._checkForUpdateField(value);
    }
  };

  _checkForUpdateField = currentValue => {
    const { id, value: initialValue } = this.props.initialProps;
    if (initialValue !== currentValue) {
      this.props._updateField(id, currentValue);
      this.props.filledStatus(true);
    }
  };

  _getDefaultValue = (type, value) => {
    let obj = {};
    if (Array.isArray(value) === true) {
      obj = { value: value[0], label: value[0] };
    } else {
      obj = { value, label: value };
    }
    return obj;
  };

  _getOptions = (options, fieldName) => {
    let sortedOptions;
    if (fieldName === "billing_frequency") {
      sortedOptions = ["weekly", "monthly", "yearly"];
    } else {
      sortedOptions = options;
    }
    return sortedOptions;
  };

  render() {
    const {
      id,
      type,
      value,
      meta,
      // docIsLocked,
      field_name: fieldName,
    } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.state.singleLineTextFieldValues}
          customFieldName={type}
          customFieldComponentRules={CustomFieldComponentRules}
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const { handleChangeByName } = formProps;
            return (
              <React.Fragment>
                <ReactSelect
                  name="default"
                  options={this._getOptions(meta.options, fieldName)}
                  value={this._getDefaultValue("SINGLE_SELECT", value)}
                  onChange={v =>
                    this._handleOnChange(v.value, handleChangeByName)
                  }
                  isDisabled={this.props.isLocked}
                  data-test="commonselectfieldformmode-react-select"
                />
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/CommonSelectFieldFormMode.js